import axios from "axios";

export default function ScheduleDeleteService(groupId, id) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/schedule/" + groupId + "/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
